<h2 mat-dialog-title>Informasi Cuti</h2>
<div mat-dialog-content>
    <div class="row">
        <table class="table full-width">
            <tr app-tr label="Nomor" [value]="data.nomor"></tr>
            <tr app-tr label="Nama" [value]="data.user?.fullname"></tr>
            <tr app-tr label="Catatan Atasan" [value]="data.catatanAtasan"></tr>
            <tr app-tr label="Catatan Pejabat" [value]="data.catatanPejabat"></tr>
            <tr *ngFor="let item of saldo" app-tr [label]="item.label" [value]="item.total"></tr>
        </table>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-raised-button mat-dialog-close color="primary" *ngIf="!isLoading">Tutup</button>
    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
</div>